'use client';

import { AppBar, Box, Container, Toolbar } from '@mui/material';
import { SelectAccountMenu } from '../SelectAccountMenu';
import { useSession } from 'next-auth/react';
import { PORTAL_USE_TYPE } from '@/types/types';
import NormalLogo from '@/../public/logo_normal.png';
import WhiteLogo from '@/../public/logo_white.png';

export function ReceptHeader() {
  const { data: session } = useSession();
  const useType = session?.user?.use_type;

  return (
    <AppBar
      position="sticky"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        boxShadow: '0px 0.5px 2px 0px #0000001A, 0px 0px 2px 0px #0000001A',
        bgcolor:
          useType === PORTAL_USE_TYPE.PORTAL_STAFF
            ? '#3EC9BE'
            : useType === PORTAL_USE_TYPE.REQUEST_USER
              ? '#FFFFFF'
              : '#FFFFFF',
        color: useType === PORTAL_USE_TYPE.REQUEST_USER ? '#13131D' : undefined,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {useType === PORTAL_USE_TYPE.PORTAL_STAFF ? (
              <Box
                component="img"
                src={WhiteLogo.src}
                alt="けあログっとロゴ"
                sx={{
                  height: '64px',
                  '@media (max-width: 600px)': { height: '56px' },
                }}
              />
            ) : (
              <Box
                component="img"
                src={NormalLogo.src}
                alt="けあログっとロゴ"
                sx={{
                  height: '64px',
                  '@media (max-width: 600px)': { height: '56px' },
                }}
              />
            )}
          </Box>
          {useType && <SelectAccountMenu />}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
